/**
 * Fix html native anchor, caused by sticky header.
 */
export const initAnchor = () => {
  const anchors = document.querySelectorAll('.anchor');

  if (anchors) {
    for (let i = 0; i < anchors.length; i++) {
      anchors[i].addEventListener('click', function goToAnchorTarget(e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        document.querySelector(href).scrollIntoView(
          { behavior: 'instant', block: 'center' },
        );
      });
    }
  }
};
